import { Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class KeycloakService {
  private keycloak: Keycloak;
  private _initialized = false;

  constructor() {
    this.keycloak = new Keycloak({
      url: environment.KeycloakUrl,
      realm: 'seedexpert',
      clientId: 'seedexpert-client',
    });
  }

  async init(): Promise<boolean> {
    if (this._initialized) return true;

    const authenticated = await this.keycloak.init({
      onLoad: 'login-required',
      checkLoginIframe: false,
      silentCheckSsoRedirectUri:
        window.location.origin + '/silent-check-sso.html',
    });

    this._initialized = true;
    return authenticated;
  }

  isAuthenticated(): boolean {
    return this._initialized && !!this.keycloak.token;
  }

  logout(): Promise<void> {
    return this.keycloak.logout({ redirectUri: window.location.origin });
  }

  login(): Promise<void> {
    return this.keycloak.login();
  }
  get token() {
    return this.keycloak.token;
  }

  get username() {
    return this.keycloak.tokenParsed?.['preferred_username'];
  }

  get roles() {
    return this.keycloak.tokenParsed?.['realm_access']?.['roles'] || [];
  }

  hasRole(role: string): boolean {
    return this.roles.includes(role);
  }

  getParsedToken(): Keycloak.KeycloakTokenParsed | undefined {
    return this.keycloak.tokenParsed;
  }

  isTokenExpired(): boolean {
    return this.keycloak.isTokenExpired();
  }

  async getValidToken(): Promise<string | null> {
    if (this.keycloak.isTokenExpired()) {
      try {
        await this.keycloak.updateToken(30); // refresh if expiring in 30s
      } catch (err) {
        return null;
      }
    }
    return this.keycloak.token ?? null;
  }
}
